import { theme } from "@tm/utility/global";
import styled from "styled-components";
import { deviceType } from "../../utils";

export const Page = styled.div`
  background: ${theme.smokeWhite};
  min-height: 100vh;
`;

export const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  @media ${deviceType.mobile} {
    width: 100%;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0 40px;
  @media ${deviceType.mobile} {
    padding: 16px;
    gap: 16px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 16px;
  position: relative;
  z-index: 2;
  @media ${deviceType.mobile} {
    grid-template-columns: 1fr;
  }
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Card = styled.div`
  background: ${theme.whiteText};
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
`;

export const CardPadding = styled.div`
  padding: 20px;
  @media ${deviceType.mobile} {
    padding: 16px;
  }
`;
